export default __webpack_public_path__ + "static/media/super-hrdinovia.cd059080.svg";